<template>
  <div class="aside-detail"
       style="text-align: left;">
    <!-- 用户基本信息 -->
    <el-row class="info-section">
      <el-col>
        <el-row>
          <el-col :span=20
                  class="section-title">
            <b>
              <span>基本信息（微信昵称：{{ this.detail.nickname || '无' }}）</span>
              <span v-if="detail.basic_info['guest']">(游客)</span>&nbsp;
              <span v-if="detail.basic_info['deleted']"
                    style="color: red">(已删除)</span>&nbsp;
            </b>
            <el-button v-show="showButtons && checkAC('/front/user_clean_oauth')"
                       @click="confirmClean()"
                       size="small"
                       type="danger"
                       plain>注销账号<i class="el-icon-delete el-icon--right"></i></el-button>
          </el-col>
          <el-col :span=4>
            <el-button @click="refresh()"
                       size="small"
                       type="primary"
                       plain>刷新<i class="el-icon-refresh el-icon--right"></i></el-button>
          </el-col>
          <el-col>
            <hr/>
          </el-col>
        </el-row>
        <row-table class="info-body"
                   :row_list="this.basic_info"/>
      </el-col>
    </el-row>

    <!-- 家庭信息 -->
    <el-row class="info-section">
      <el-col>
        <el-row class="section-title">
          <b>
            家庭信息（{{ this.detail.family_data.user_role || '未填写' }}，
            {{ this.detail.family_data.member_count || 0 }}个成员，
            {{ this.detail.family_data.core_count || 0 }}个核心成员）
          </b>
          <el-button @click="exportAnswer()"
                     size="small"
                     type="primary"
                     plain>导出答案<i class="el-icon-download el-icon--right"></i></el-button>
          <el-button v-show="hasServiceQuestion"
                     @click="handleServiceQuestion"
                     size="small"
                     type="primary"
                     plain>1V1问卷
          </el-button>
          <hr/>
        </el-row>
        <el-row v-if="!('user_role' in detail.family_data) || detail.family_data.user_role == ''"
                class="info-body">
          <el-col>无</el-col>
        </el-row>
        <el-row v-else
                class="info-body">
          <el-col>
            <!-- 家庭成员 -->
            <el-row>
              <b>家庭成员：</b>
              <toggle-expand v-model="show_family"/>
            </el-row>
            <el-row v-show="show_family">
              <el-row>
                <el-col :span=4>生日(年龄)</el-col>
                <el-col :span=4>角色</el-col>
                <el-col :span=4>退休</el-col>
                <el-col :span=12>收入</el-col>
              </el-row>
              <el-row v-for="(item) in this.detail.family_data.backbone"
                      :key="'in_' + item.role">
                <el-col :span=4>{{ item.birthyear }}({{ new Date().getFullYear() - item.birthyear }})</el-col>
                <el-col :span=4>{{ item.role }}</el-col>
                <el-col :span=4>{{ item.retire_age }}</el-col>
                <el-col :span=12>{{ formatInOutcome(item.income) }}</el-col>
              </el-row>
              <el-row v-for="(item) in this.detail.family_data.children"
                      :key="'in_' + item.member_code">
                <el-col :span=4>{{ new Date().getFullYear() - item.age }}({{ item.age }})</el-col>
                <el-col :span=20>{{ item.member_code }}</el-col>
              </el-row>
              <el-row v-for="(item) in this.detail.family_data.parents"
                      :key="'in_' + item.member_code">
                <el-col :span=4>{{ new Date().getFullYear() - item.age }}({{ item.age }})</el-col>
                <el-col :span=20>{{ item.member_code }}</el-col>
              </el-row>
              <el-row>
                <el-col :span=4>-</el-col>
                <el-col :span=4>其他</el-col>
                <el-col :span=4>-</el-col>
                <el-col :span=12>{{ formatInOutcome(this.detail.family_data.non_backbone_income) }}</el-col>
              </el-row>
            </el-row>

            <!-- 家庭支出 -->
            <el-row>&nbsp;<br/></el-row>
            <el-row>
              <b>家庭支出：</b>
              <toggle-expand v-model="show_outcome"/>
            </el-row>
            <el-row v-show="show_outcome">
              <el-row>
                <el-col :span=10>角色</el-col>
                <el-col :span=2>类型</el-col>
                <el-col :span=12>费用</el-col>
              </el-row>
              <el-row v-for="(e, i) in this.fee_out"
                      :key="'out_' + i">
                <el-col :span=10>{{ e.role }}</el-col>
                <el-col :span=2>{{ e.type }}</el-col>
                <el-col :span=12>{{ formatInOutcome(e.fee) }}</el-col>
              </el-row>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <!-- 备注 -->
    <el-row class="info-section">
      <el-col>
        <el-row class="section-title">
          <b>备注</b>&nbsp;
          <el-button @click="modifyRemarks() && checkAC('/front/user_set_remarks')"
                     size="small"
                     type="primary"
                     plain><i class="el-icon-edit"></i></el-button>
          <hr/>
        </el-row>
        <el-row class="info-body">
          <el-col style="white-space: pre-line">{{ this.detail.remarks || '无' }}</el-col>
        </el-row>
      </el-col>
    </el-row>

    <!-- 已有保单 -->
    <el-row class="info-section">
      <el-row class="section-title">
        <b>已有保单</b>&nbsp;
        <el-button v-show="showButtons"
                   @click="inputOrder() && checkAC('/front/user_add_plan_order')"
                   size="small"
                   type="primary"
                   plain>录入保单<i class="el-icon-upload el-icon--right"></i></el-button>
        <hr/>
      </el-row>
      <el-row class="info-body">
        <el-col>
          <el-table
            :data="this.orders"
            style="width: 100%"
            class="order-table-row">
            <el-table-column type="expand"
                             width="30px">
              <template slot-scope="props">
                <el-row style="padding-left: 30px; padding-right: 10px">
                  <el-row>
                    <el-col :span="4"><b>ID：</b></el-col>
                    <el-col :span="20"><span>{{ props.row['id'] }}</span></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4"><b>产品ID：</b></el-col>
                    <el-col :span="20"><span>{{ props.row['product_id'] }}</span></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4"><b>公司：</b></el-col>
                    <el-col :span="20"><span>{{ props.row['policy_info']['company'] }}</span></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4"><b>缴费年限：</b></el-col>
                    <el-col :span="20">{{ props.row['payment_period'] }}年</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4"><b>保单号：</b></el-col>
                    <el-col :span="20">{{ props.row['policy_info']['policy_id'] }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4"><b>等待期：</b></el-col>
                    <el-col :span="20">{{ props.row['policy_info']['waiting_period'] }}天</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4"><b>缴费银行：</b></el-col>
                    <el-col :span="20">{{ props.row['policy_info']['payment_bank'] }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4"><b>缴费卡号：</b></el-col>
                    <el-col :span="20">{{ props.row['policy_info']['payment_num'] }}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4"><b>投保时间：</b></el-col>
                    <el-col :span="20"><span>{{ props.row['insure_date'] }}</span></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4"><b>录入时间：</b></el-col>
                    <el-col :span="20"><span>{{ props.row['time'] }}</span></el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4"><b>是否删除：</b></el-col>
                    <el-col :span="20"><span>{{ props.row['is_del'] === 1 ? '是' : '否' }}</span></el-col>
                  </el-row>
                </el-row>
              </template>
            </el-table-column>
            <el-table-column label="角色"
                             prop="role"
                             width="70px"/>
            <el-table-column label="保障期限"
                             prop="period"
                             width="100px"/>
            <el-table-column label="保费"
                             prop="fee"
                             width="80px"/>
            <el-table-column label="保额"
                             prop="amount"
                             width="60px"/>
            <el-table-column label="产品名称"
                             prop="product_name"
                             min-width="200px"/>
          </el-table>
        </el-col>
      </el-row>
    </el-row>

    <!-- 已有方案 -->
    <el-row class="info-section">
      <el-row class="section-title">
        <b>已有方案</b>
        <hr/>
      </el-row>
      <el-row class="info-body">
        <el-col>
          <el-row v-for="(p, idx) in this.plans"
                  :key="'plan_' + p.id">
            <el-row><b>方案{{ idx }}{{ p.selected ? '（当前已选中）' : '' }}</b></el-row>
            <el-row class="info-body">
              <row-table :row_list="p.info"/>
              <el-col>
                <b>方案列表：</b>
                <toggle-expand v-model="p.show_orders"/>
              </el-col>
              <el-table v-show="p.show_orders"
                        :data="detail.plan[idx].order_list"
                        style="width: 100%"
                        class="order-table-row">
                <el-table-column type="expand"
                                 width="30px">
                  <template slot-scope="props">
                    <el-row style="padding-left: 30px; padding-right: 10px">
                      <el-row>
                        <el-col :span="4"><b>ID：</b></el-col>
                        <el-col :span="20"><span>{{ props.row['id'] }}</span></el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="4"><b>产品ID：</b></el-col>
                        <el-col :span="20"><span>{{ props.row['product_id'] }}</span></el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="4"><b>公司：</b></el-col>
                        <el-col :span="20"><span>{{ props.row['company_name'] }}</span></el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="4"><b>减额：</b></el-col>
                        <el-col :span="20"><span>{{ props.row['decrease'] ? '是' : '否' }}</span></el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="4"><b>购买链接：</b></el-col>
                        <el-col :span="20"
                                style="overflow: auto; white-space:nowrap; ">{{ props.row['url'] }}
                        </el-col>
                      </el-row>
                      <el-row>
                        <el-col :span="4"><b>缴费年限：</b></el-col>
                        <el-col :span="20">{{ props.row['payment_period'] }}年</el-col>
                      </el-row>
                    </el-row>
                  </template>
                </el-table-column>
                <el-table-column label="角色"
                                 prop="role"
                                 width="70px"/>
                <el-table-column label="保障"
                                 prop="period"
                                 :formatter="function(r, c, v, i) {
                    return r['period'] > 0 ? r['period'] + '年' : '到' + r['to_age'] + '岁'
                  }"
                                 width="60px"/>
                <el-table-column label="保费"
                                 prop="fee"
                                 :formatter="function(_1, _2, v, _3) { return '' + v / 100 + '元'; }"
                                 width="80px"/>
                <el-table-column label="保额"
                                 prop="amount"
                                 :formatter="function(_1, _2, v, _3) { return '' + v / 10000 + '万'; }"
                                 width="60px"/>
                <el-table-column label="产品名称"
                                 prop="product_name"
                                 min-width="200px"/>
              </el-table>
            </el-row>
          </el-row>
        </el-col>
      </el-row>
    </el-row>
    <el-dialog title="答案"
               :visible.sync="showDumppedAnswer"
               width="60%">
      <el-input type="textarea"
                :rows="25"
                placeholder="请输入内容"
                v-model="this.answer_list"
                readonly="true">
      </el-input>
    </el-dialog>

    <el-dialog title="录入保单"
               :visible.sync="showInputOrder"
               width="700px">
      <input-order v-model="showInputOrder"
                   :user-id="userId"
                   :order-id="editOrderId"/>
    </el-dialog>

    <el-dialog title="清空用户信息"
               :visible.sync="showCleanData"
               width="400px">
      <div style="margin: 0 10px;">
        <p style="margin: 0; font-size: 16px">此操作将要清空用户的所有数据，如要继续请在下面框中输入<span style="color: red">注销账号</span></p>
        <br/>
        <el-input v-model='iWantClean'
                  placeholder="请输入"></el-input>
        <span style="color: red">{{ cleanError }}</span>
      </div>
      <div style="text-align: center; margin-top: 10px">
        <el-button @click="cleanUserData()"
                   type="danger">清空
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="修改备注"
               :visible.sync="showModifyRemarks"
               width="600px">
      <el-input type="textarea"
                :rows="10"
                placeholder="请输入内容"
                v-model="remarks">
      </el-input>

      <div style="text-align: center; margin-top: 10px">
        <el-button @click="doModifyRemarks()"
                   type="primary"
                   :disabled="remarks === detail.remarks">更新
        </el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="showServiceQuestion">
      <el-table :data="serviceQuestionTable">
        <el-table-column label="ID"
                         prop="key"/>
        <el-table-column label="答案"
                         prop="value"/>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import event from '../../api/event'
import request from "../../api/request"
import RowTable from "./RowTable"
import InputOrder from './InputOrder'
import ToggleExpand from '../ui/ToggleExpand'
import {isArray} from 'lodash'
import {mapGetters} from 'vuex'

export default {
  name: 'UserDetail',
  components: {RowTable, InputOrder, ToggleExpand},
  props: {
    userId: {
      type: Number,
      default: 0
    },
    personId: {
      type: Number,
      default: 0
    },
    showButtons: {
      type: Boolean,
      default: true
    },
    model: {
      type: String,
      default: 'front'
    }
  },
  data() {
    return {
      expended_orders: {},
      show_family: true,
      show_outcome: false,
      showModifyRemarks: false,
      remarks: '',
      showCleanData: false,
      iWantClean: '',
      cleanError: '',
      showInputOrder: false,
      showDumppedAnswer: false,
      answer_list: [],
      detail: {
        basic_info: {},
        family_data: {},
        fee: {},
        plan: []
      },
      basic_info: [],
      fee_out: [],
      plans: [],
      orders: [],
      serviceQuestion: '',
      showServiceQuestion: false,
      editOrderId: 0
    }
  },
  created() {
    if (this.userId) {
      this.refresh()
      this.getServiceQuestion()
    }
  },
  watch: {
    userId: function () {
      this.refresh()
    }
  },
  computed: {
    hasServiceQuestion: function () {
      return !!this.serviceQuestion
    },
    serviceQuestionTable: function () {
      let s = JSON.parse(this.serviceQuestion || '[]')
      let data = []
      for (let item of s) {
        data.push({
          key: item.id,
          value: isArray(item.answer) ? item.answer.join(',') : item.answer
        })
      }
      return data
    },
    ...mapGetters(['ac'])
  },
  methods: {
    expandOrders(plan_id) {
      this.expended_orders[plan_id] = !this.expended_orders[plan_id]
    },
    checkAC(path) {
      return this.ac.check(path)
    },
    refresh() {
      request[this.model]
        .post('user_get_detail', {
          uid: this.userId,
          pid: this.personId
        })
        .then(resp => {
          try {
            let d = resp.data
            this.detail = d

            // 基础信息
            this.basic_info = [
              [
                {span: 6, key: 'ID', val: d.basic_info.id},
                {span: 8, key: '手机号', val: d.basic_info.mobile},
                {span: 10, key: '注册时间', val: d.basic_info.time}
              ],
              [
                {
                  span: 6,
                  key: '邀请人',
                  val: d.basic_info.invite_id,
                  href: (d.basic_info.invite_id ? '/#/user/detail/' + d.basic_info.invite_id : '')
                },
                {span: 8, key: '渠道号', val: d.basic_info.cid},
                {
                  span: 10,
                  key: '1V1服务',
                  val: d.basic_info.buy_vip_time
                }
              ],
              [
                {span: 12, key: '最后登陆IP', val: this.detail.basic_info.last_ip}
              ]
            ]

            // 支出信息
            this.fee_out = [
              {role: '-', type: '基础', fee: d.family_data.fee.basic_live},
              {role: '-', type: '房子', fee: d.family_data.fee.house},
              {role: '-', type: '可选', fee: d.family_data.fee.optional}
            ]
            for (let e of d.family_data.fee.loan) {
              this.fee_out.push({role: '-', type: '贷款', fee: e})
            }
            for (let e in d.family_data.fee.education) {
              this.fee_out.push({
                role: e,
                type: '教育',
                fee: d.family_data.fee.education[e]
              })
            }
            for (let e in d.family_data.fee.support_parent) {
              this.fee_out.push({
                role: e,
                type: '赡养',
                fee: d.family_data.fee.support_parent[e]
              })
            }

            // 方案
            let plans = []
            for (let p of d.plan) {
              let plan = {
                id: p.id,
                show_orders: !!this.expended_orders[p.id],
                selected: p.selected,
                order_info: (order_info_text => {
                  try {
                    return JSON.parse(order_info_text)
                  } catch (e) {
                    e
                  }
                  return []
                })(p.order_info),
                info: [
                  [
                    {span: 7, key: 'ID', val: p.id},
                    {
                      span: 7,
                      key: '代理人',
                      val: p.agent_id === 1 ? '系统' : p.agent_id
                    },
                    {span: 10, key: '分数', val: p.score}
                  ],
                  [
                    {span: 7, key: '保费', val: p.amount / 100 + '元'},
                    {span: 17, key: '最大保费', val: p.max_fee / 100 + '元'}
                  ],
                  [{span: 24, key: '创建时间', val: p.time}],
                  [{span: 24, key: '最后更新时间', val: p.update_time}]
                ],
                orders: []
              }

              plans.push(plan)
            }

            this.plans = plans
            this.orders = d.orders
            d.orders.map((order => {
              order.fee = order.fee / 100 + '元'
              order.amount = order.amount / 1000000 + '万'
              order.period = order.coverage_period === 999 ? '终身' : order.policy_info.coverage_period.ages.length ? order.coverage_period + '岁' : order.coverage_period + '年'
            }))
            event.broadcast('message', '刷新成功')
          } catch (e) {
            console.error(e)
          }
        })
    },
    formatInOutcome(incomes) {
      let v = []

      let last = -1
      let count = 0
      for (let e of incomes) {
        if (e !== last) {
          if (last >= 0) {
            v.push('' + last / 10000 + 'w*' + count)
          }
          count = 0
          last = e
        }
        count++
      }

      if (count > 0) {
        v.push('' + last / 10000 + 'w*' + count)
      }

      return v.join(', ')
    },
    exportAnswer() {
      request.front.post('user_get_question_answer', {uid: this.personId || this.userId}).then(resp => {
        this.answer_list = resp.data.result.join("\n")
        this.showDumppedAnswer = true
      })
    },
    confirmClean: function () {
      this.iWantClean = '';
      this.showCleanData = true;
    },
    cleanUserData: function () {
      if (this.iWantClean === '注销账号') {
        this.iWantClean = '';
        this.showCleanData = false;
        this.cleanError = '';

        this.$confirm('此操作是永久性不可恢复删除!', '是否继续', '警告').then(
          () => {
            request.front
              .post('user_clean_oauth', {
                uid: this.userId
              })
              .then(resp => {
                if (resp.data) {
                  this.$message.success('清除用户授权成功')
                } else {
                  this.$message.error('清除用户失败')
                }

                this.refresh()
              })
          }
        )
      } else {
        this.cleanError = '请输入正确的内容'
      }
    },
    inputOrder: function (uid) {
      this.showInputOrder = true
      this.currentUID = uid
      this.editOrderId = 0
    },
    modifyRemarks: function () {
      this.showModifyRemarks = true
      this.remarks = this.detail.remarks
    },
    doModifyRemarks: function () {
      this.detail.remarks = this.remarks
      this.showModifyRemarks = false

      request.front.post("user_set_remarks", {
        uid: this.userId,
        remarks: this.detail.remarks || ''
      }).then(() => {
      })
    },
    getServiceQuestion: function () {
      request.front.post('user_get_data', {
        user_id: this.personId || this.userId,
        name: 'ap'
      }).then(resp => {
        if (resp.data.length > 0) {
          this.serviceQuestion = resp.data
        }
      })
    },
    handleServiceQuestion: function () {
      this.showServiceQuestion = true
    },
    handleEditOrder: function (id) {
      this.editOrderId = id
      this.showInputOrder = true
    }
  },
}
</script>
<style scoped>
>>> .order-table-row td {
  padding: 0;
}

>>> .order-table-row .cell {
  padding: 0 5px;
}

.aside-detail .el-main {
  padding: 0;
}

.aside-detail {
  font-size: 15px;
  border-right: 1px solid #ebeef5;
  padding-right: 5px;
  height: 100%;
  overflow-y: auto;
}

.info-section {
  margin-bottom: 20px;
}

.info-body {
  padding-left: 5px;
}

.section-title {
  font-size: 15px;
}
</style>
